import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from '@/lib/monitoring/sentry';
import { reportWebVitals } from '@/lib/monitoring/web-vitals';
import App from '@/App';
import '@/styles/globals.css';

initSentry();
reportWebVitals();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
